






























































































































import Vue from 'vue'
import { Location as FirestoreLocation } from '@/models'
import { Location } from '@/models/api'
import CelebrationIcon from '@/assets/pmd/img/celebration.svg'
import { ChatWidgetService } from '../../../services'
export default Vue.extend({
  components:{CelebrationIcon},
  props: [
    'cms',
    'instruction',
    'currentStep',
    'screenshot',
    'chatIntegrated',
    'widgetSettings',
  ],
  data() {
    return {
      showCopiedCodeToolTip: false,
      widgetPrimaryColor: '#188bf6',
      steps: [] as any,
      locationId: '',
      location: {} as Location,
      scriptCode: ''
    }
  },
  async mounted() {
    this.locationId = this.$router.currentRoute.params.location_id
    this.location = new FirestoreLocation(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.locationId
      )
    )
    if (this.cms) this.steps = this.instruction.steps
    await this.getScriptCode()
  },
  watch: {
    cms: async function () {
      this.steps = this.instruction.steps
    },
  },
  methods: {
    async copyToClipboard() {
      try {
        this.showCopiedCodeToolTip = true
        if (this.steps[this.currentStep].widgetCode) {
          this.clipboardCopy(this.scriptCode)
        } else if (this.steps[this.currentStep].apiKey) {
          const res = await Location.getKeyByLocationId(this.locationId)
          this.clipboardCopy(res?.apiKey)
        }
        setTimeout(() => this.showCopiedCodeToolTip = false, 2000);
      } catch (err) {
        setTimeout(() => this.showCopiedCodeToolTip = false, 2000);
        console.error(err)
      }
    },
    getImgUrl(pic: string) {
      const images = require.context(
        '../../../assets/pmd/img/launchpad/',
        false,
        /(\.png|\.svg)$/
      )
      return images('./' + pic)
    },
    async getScriptCode() {
      try {
        const { data } = await ChatWidgetService.getCode(this.locationId)
        this.scriptCode = data.code
      } catch (error) {
        this.scriptCode = ''
      }
    },
  },
  computed: {
    apiKey() {
      let key = this.location.apiKey || '*'.repeat(16);
      if (!key || key.length < 1) return
      return `${key.slice(0, 4)}****-****-****-****-******${key.slice(-6)}`
    },
  }
})
